module.exports = __webpack_public_path__ + "static/img/extended-insurance-1.a82dbd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/my/extended-insurance-1.png
// module id = a3sN
// module chunks = 1